import Head from "next/head";
import React from "react";
import { ExtendedNextPage } from "types/pages";

import styles from "./styles.module.scss";

const Read: ExtendedNextPage = () => {
  return (
    <div className={styles.container}>
      <Head>
        <title>Service Offerings | Humming Homes</title>
        <meta
          name="description"
          content="Learn more about the core services that we provide."
        />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <iframe
        src="https://drive.google.com/file/d/1J4NL6qrMv9qwFnTZCT-JzWiyZdikGX_Q/preview"
        width="960"
        height="720"
        allow="autoplay"
        frameBorder={0}
        className={styles.iframe}
        title="Service offerings"
      />
    </div>
  );
};

export default Read;
